import React from 'react';

export type MediaFailure = 'microphone' | 'silence' | 'scoring' | 'network' | 'audio';

// Review-only URL fixture. Each matching mounted control fails once, then its
// recovery action succeeds. No microphone, audio upload or network is involved.
export default function useMockMediaFailure() {
    const pending = React.useRef(new URLSearchParams(window.location.search).get('previewError'));
    return (...allowed: MediaFailure[]): MediaFailure | null => {
        const failure = pending.current as MediaFailure;
        if (!allowed.includes(failure)) return null;
        pending.current = null;
        return failure;
    };
}
